import React, { Component } from 'react'
import 'bootstrap/dist/css/bootstrap.css';
import { CardDeck, Row, Col, Container, Card } from 'react-bootstrap'

import ReactApexChart from "react-apexcharts";
import '../../css/Charts.css'


class BarGraphs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            options: {
                chart: {
                    id: props.id,
                    height:'200'
                },

                plotOptions: {
                    bar: {
                        distributed: true
                    }
                },
                xaxis: {
                    categories: props.categories
                },
                legend: {
                    show: false
                }
                ,
                fill: {
                    colors: ['#DD1D21']
              }
            },
            series: [
                {
                    name: Math.random(),
                    data: props.data
                }
                
            ]

        };

    }

    render() {

        return (

            <div>


                <Card className="CardGraph">
                    <Card.Title>

                        <h5 class="text-left" style={{padding: 10}}>
                            {this.props.title}
                        </h5>

                    </Card.Title>

                    <Card.Body>



                        <div className="mixed-chart">
                            <ReactApexChart
                                options={this.state.options}
                                series={this.state.series}
                                type="bar"
                                height="400"
                            />
                        </div>

                    </Card.Body>


                </Card>

            </div>

        );
    }
}

export default BarGraphs;